import { render, staticRenderFns } from "./SavedPricelists.vue?vue&type=template&id=7f855c06&"
import script from "./SavedPricelists.vue?vue&type=script&lang=ts&"
export * from "./SavedPricelists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports